import Scene from '../../Scene/Scene';
import Point from '../../Utility/Point';
import GameObject from '../../GameObject/GameObject';
import ScoreCardEffect from '../../Prototype/Effect/ScoreCardEffect';
import CoinCardEffect from '../../Prototype/Effect/CoinCardEffect';
import { ObservablePoint } from 'pixi.js';
import BaseCard from '../../Prototype/Level/Card/BaseCard';
import TransformComponent from '../../Component/Transform';

export function showCardScoreEffect(scene: Scene, card: BaseCard): void {
    showCardScoreEffectAt(
        scene,
        card.parent,
        card.score,
        card.getComponent(TransformComponent).position.clone()
    );
}

export function showCardScoreEffectAt(
    scene: Scene,
    parent: GameObject,
    score: number,
    position: Point | ObservablePoint
): void {
    if (score > 0) {
        parent.addChild(
            GameObject.Instantiate(ScoreCardEffect, {
                text: `+${score}`,
                position: position,
            })
        );

        scene.emit('UpdateScoreProgress');
    }
}

export function showCardCoinEffectAt(
    scene: Scene,
    parent: GameObject,
    value: number,
    position: Point | ObservablePoint
): void {
    if (value > 0) {
        const effect: ScoreCardEffect = GameObject.Instantiate(CoinCardEffect, {
            text: `+${value}`,
            position: position,
        });
        parent.addChild(effect);
    }
}
